var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { RRule as RRuleLib } from "rrule";
import StringService from "../../Services/Shared/String.service";
import DateService from "../../Services/Shared/Date.service";
export default class RRuleDomainService {
    static fromString(rrule) {
        if (!rrule) {
            // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'RRule'.
            return null;
        }
        // @ts-expect-error - TS2339 - Property 'dsStart' does not exist on type 'Partial<Options>'.
        const _a = RRuleLib.parseString(rrule), { dsStart } = _a, other = __rest(_a, ["dsStart"]);
        // @ts-expect-error - TS2322 - Type '{ freq?: Frequency | undefined; dtstart?: Date | null | undefined; interval?: number | undefined; wkst?: number | Weekday | null | undefined; count?: number | null | undefined; ... 13 more ...; byeaster?: number | ... 1 more ... | undefined; }' is not assignable to type 'RRule'.
        return other;
    }
    static toString(rrule) {
        return new RRuleLib(rrule).toString();
    }
    static toText(rrule) {
        var _a;
        return (_a = StringService.capitalize(new RRuleLib(rrule).toText())) !== null && _a !== void 0 ? _a : "";
    }
    static getNextOccurrences(rrule, numberOfOccurrences) {
        return new RRuleLib(rrule)
            .all((_, i) => i < numberOfOccurrences)
            .map((date) => DateService.parseDateWithSameTimeInLocalTimezone(date));
    }
    static getNextOccurrencesAfter(rrule, numberOfOccurrences, start, after = new Date()) {
        let numFound = 0;
        const dates = new RRuleLib(Object.assign(Object.assign({}, rrule), { dtstart: new Date(Date.UTC(start.getFullYear(), start.getMonth(), start.getDate(), start.getHours(), start.getMinutes(), start.getSeconds())) })).all((d, i) => {
            const date = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes());
            if (date.getTime() >= after.getTime()) {
                numFound += 1;
            }
            return numFound <= numberOfOccurrences;
        });
        return dates
            .slice(Math.max(0, dates.length - Math.min(numFound, numberOfOccurrences)))
            .map((date) => new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes()));
    }
    static getOneTimeRRuleString() {
        return "RRULE:FREQ=DAILY;INTERVAL=1;COUNT=1";
    }
    static getOneTimeRRule() {
        return RRuleDomainService.fromString(RRuleDomainService.getOneTimeRRuleString());
    }
}
